const showPassword = () => {
	$('.showPassword, .hidePassword').on('click keypress', function () {
		var thisInput = $(this).siblings('input');
		if ($(thisInput).attr('type') === 'password') {
			$(thisInput).attr('type', 'text');
			$('.showPassword').hide();
			$('.hidePassword').show();
		} else {
			$(thisInput).attr('type', 'password');
			$('.hidePassword').hide();
			$('.showPassword').show();
		}
	});
};

// function for the confirm password inputs
const confirmShowPassword = () => {
	$('.verifyShowPassword, .verifyHidePassword').on('click keypress', function () {
		var thisOtherInput = $(this).siblings('input');
		if ($(thisOtherInput).attr('type') === 'password') {
			$(thisOtherInput).attr('type', 'text');
			$('.verifyShowPassword').hide();
			$('.verifyHidePassword').show();
		} else {
			$(thisOtherInput).attr('type', 'password');
			$('.verifyHidePassword').hide();
			$('.verifyShowPassword').show();
		}
	});
};

const personalInfoPagePassword = () => {
	if ($('.personal-info-page').length > 0) {
		$('.personal-info-page #createAcctColumn #create-password, .personal-info-page #createAcctColumn #verify-choose-password').on('focus', function () {
			if ($(this).val() === '************') {
				$(this).val('');
				$(this).siblings('span[aria-label="Show Password"]').show();
			}
		});
		$('.personal-info-page #createAcctColumn #create-password, .personal-info-page #createAcctColumn #verify-choose-password').on('blur', function () {
			if ($(this).val() !== '************' && $(this).val() == '') {
				$(this).val('************');
				$(this).siblings('span[aria-label="Show Password"]').hide();
				$(this).siblings('span[aria-label="Hide Password"]').hide();
				$(this).attr('type', 'password');
			}
		});
	}
};



export { showPassword, confirmShowPassword, personalInfoPagePassword };
